// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

function oneClickWallets(localeString) {
  return [
          {
            paymentMethodType: "apple_pay",
            displayName: localeString.payment_methods_apple_pay
          },
          {
            paymentMethodType: "samsung_pay",
            displayName: localeString.payment_methods_samsung_pay
          },
          {
            paymentMethodType: "paypal",
            displayName: localeString.payment_methods_paypal
          },
          {
            paymentMethodType: "google_pay",
            displayName: localeString.payment_methods_google_pay
          },
          {
            paymentMethodType: "klarna",
            displayName: localeString.payment_methods_klarna
          }
        ];
}

function useSurchargeDetailsForOneClickWallets(paymentMethodListValue) {
  var areOneClickWalletsRendered = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.areOneClickWalletsRendered);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  return React.useMemo((function () {
                return Core__Array.reduce(oneClickWallets(localeString), [], (function (acc, wallet) {
                              var match = wallet.paymentMethodType;
                              var match$1;
                              switch (match) {
                                case "apple_pay" :
                                    match$1 = [
                                      areOneClickWalletsRendered.isApplePay,
                                      "wallet"
                                    ];
                                    break;
                                case "google_pay" :
                                    match$1 = [
                                      areOneClickWalletsRendered.isGooglePay,
                                      "wallet"
                                    ];
                                    break;
                                case "klarna" :
                                    match$1 = [
                                      areOneClickWalletsRendered.isKlarna,
                                      "pay_later"
                                    ];
                                    break;
                                case "paypal" :
                                    match$1 = [
                                      areOneClickWalletsRendered.isPaypal,
                                      "wallet"
                                    ];
                                    break;
                                case "samsung_pay" :
                                    match$1 = [
                                      areOneClickWalletsRendered.isSamsungPay,
                                      "wallet"
                                    ];
                                    break;
                                default:
                                  match$1 = [
                                    false,
                                    ""
                                  ];
                              }
                              if (!match$1[0]) {
                                return acc;
                              }
                              var paymentMethodType = Core__Option.getOr(PaymentMethodsRecord$OrcaPaymentPage.getPaymentMethodTypeFromList(paymentMethodListValue, match$1[1], wallet.paymentMethodType), PaymentMethodsRecord$OrcaPaymentPage.defaultPaymentMethodType);
                              var surchargDetails = paymentMethodType.surcharge_details;
                              if (surchargDetails !== undefined) {
                                return acc.concat([{
                                              name: wallet.displayName,
                                              surchargeDetails: surchargDetails
                                            }]);
                              } else {
                                return acc;
                              }
                            }));
              }), [
              areOneClickWalletsRendered,
              paymentMethodListValue
            ]);
}

function useMessageGetter() {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var showShortSurchargeMessage = match$1.showShortSurchargeMessage;
  return function (surchargeDetails, paymentMethod, paymentMethodListValue) {
    var currency = paymentMethodListValue.currency;
    var surchargeValue = surchargeDetails.displayTotalSurchargeAmount.toString();
    if (showShortSurchargeMessage) {
      return Caml_option.some(localeString.shortSurchargeMessage(currency, surchargeValue));
    } else {
      return Caml_option.some(paymentMethod === "card" ? localeString.surchargeMsgAmountForCard(currency, surchargeValue) : localeString.surchargeMsgAmount(currency, surchargeValue));
    }
  };
}

function useOneClickWalletsMessageGetter(paymentMethodListValue) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var oneClickWalletsArr = useSurchargeDetailsForOneClickWallets(paymentMethodListValue);
  return function () {
    if (oneClickWalletsArr.length === 0) {
      return ;
    }
    var msg = Core__Array.reduceWithIndex(oneClickWalletsArr, null, (function (acc, wallet, index) {
            var amount = wallet.surchargeDetails.displayTotalSurchargeAmount.toString();
            var myMsg = React.createElement(React.Fragment, {}, React.createElement("strong", undefined, paymentMethodListValue.currency + " " + amount), Utils$OrcaPaymentPage.nbsp + localeString.on + " " + wallet.name);
            var msgToConcat = index === 0 ? myMsg : (
                index === (oneClickWalletsArr.length - 1 | 0) ? React.createElement(React.Fragment, {}, Utils$OrcaPaymentPage.nbsp + localeString.and + Utils$OrcaPaymentPage.nbsp, myMsg) : React.createElement(React.Fragment, {}, "," + Utils$OrcaPaymentPage.nbsp, myMsg)
              );
            return React.createElement(React.Fragment, {}, acc, msgToConcat);
          }));
    return Caml_option.some(React.createElement(React.Fragment, {}, localeString.surchargeMsgAmountForOneClickWallets + ":" + Utils$OrcaPaymentPage.nbsp, msg));
  };
}

export {
  oneClickWallets ,
  useSurchargeDetailsForOneClickWallets ,
  useMessageGetter ,
  useOneClickWalletsMessageGetter ,
}
/* react Not a pure module */
